<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: servicedefinition.component.html
 * Generated by: ianday
 * Date .......: 10/10/23
--------------------------------------->
<div class="servicedefinition-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-star fa-fw table-icon-header"
                       style="width: 2em"></i>{{formTitle}}
                </TD>

                <TD align="left" style="min-width: 400px;text-align:center">
                    <input text id="txtFilter" #txtFilter
                           matTooltip="Type to match data in all columns except date fields"
                            class="qs_filter-field" [disabled]="this.isEditing"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
                <TD style="width: 150px">
                    <dw-dropdown
                            [useStatusOptions]="'statusdiscontinuedall'"
                            [selectedItem]="selectedStatusFilter"
                            [controlWidth]="'120px'"
                            (itemSelected)="selectedStatusFilter = $event; txtFilter.value=''; onChangeStatusFilterValue()">
                    </dw-dropdown>
                </TD>
                <TD class="table-pagination-cell" align="right">{{pagination}} Record(s) ...</TD>
            </TR>
        </table>
    </div>

    <div class="main-client-area">
        <!--------------------------->
        <!-- RECORDS TABLE         -->
        <!--------------------------->
        <div #tb1 [ngClass]="contentClassName" id="mainTableId" class="table-container mat-elevation-z1"
             (keydown)="tableKeyDown($event)" tabindex="-1">
            <table mat-table [dataSource]="dataSource" matSort
                   (matSortChange)="onSortChange($event)">

                <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on
              the row definition" -->

                <!-- Position Column -->
                <ng-container matColumnDef="id" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width:85px !important; background-color: white; z-index:99999">Id
                    </th>
                    <td mat-cell style="width:85px !important;"
                        *matCellDef="let element;let tableRowIdx = index;">
                        {{element.id}}</td>
                </ng-container>

                <ng-container matColumnDef="serviceRequestTypeId" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [hidden]="true"
                        style="background-color: white; z-index:99999">Request Type
                    </th>
                    <td mat-cell [hidden]="true"
                        *matCellDef="let element">{{element.serviceRequestTypeId}}</td>
                </ng-container>

                <ng-container matColumnDef="requestType" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width: 250px !important;background-color: white; z-index:99999">Request Type
                    </th>
                    <td mat-cell style="width: 250px !important;"
                        *matCellDef="let element">{{element.requestType}}</td>
                </ng-container>
                <ng-container matColumnDef="description" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width:250px;background-color: white; z-index:99999">Description
                    </th>
                    <td mat-cell style="width: 30% !important;"
                        *matCellDef="let element">{{element.description}}</td>
                </ng-container>

                <ng-container matColumnDef="unitOfMeasure" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width: 180px !important;background-color: white; z-index:99999">Unit of Measure
                    </th>
                    <td mat-cell style="width: 180px !important;"
                        *matCellDef="let element">{{element.unitOfMeasure}}</td>
                </ng-container>


                <ng-container matColumnDef="useAutomatch" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width: 180px !important;background-color: white; z-index:99999">Use Automatch
                    </th>
                    <td mat-cell style="width: 180px !important;"
                        *matCellDef="let element">
                        <dw-dropdown *ngIf="selectedRecord?.id == element.id && visibleAdd"
                                     [disabled]="isEditing || !automatchEnabled"
                                     [useStatusOptions]="'status'"
                                     [selectedItem]="element.useAutomatch"
                                     [controlWidth]="'100px'"
                                     (itemSelected)="element.useAutomatch = $event; onUseAutomatchChange()">
                        </dw-dropdown>

                        <span *ngIf="selectedRecord?.id !== element.id || !visibleAdd"
                              style="padding-left: 3px;">{{element.useAutomatch}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="activeStatus"  style="width: 15% !important;">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width:100px;background-color: white; z-index:99999">Status
                    </th>
                    <td mat-cell *matCellDef="let element" >
                        <dw-dropdown *ngIf="selectedRecord?.id == element.id && visibleAdd"
                                     [disabled]="isEditing || !statusEnabled"
                                     [useStatusOptions]="'statusdiscontinued'"
                                     [selectedItem]="element.activeStatus"
                                     [controlWidth]="'100px'"
                                     (itemSelected)="element.activeStatus = $event; onStatusChange()">
                        </dw-dropdown>

                        <span *ngIf="selectedRecord?.id !== element.id || !visibleAdd"
                              style="padding-left: 3px;">{{element.activeStatus}}</span>
                    </td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="btnDetails" >
                    <th mat-header-cell *matHeaderCellDef mat-sort-header  class="mat-table-header-style table-header-class"
                        style="min-width:100px;">
                    </th>
                    <td mat-cell *matCellDef="let element" class="table-row-class" style="width:100px !important;">
                        <mat-icon class="command-icon-style" (click)="doInvokeQualificationMapping(element)"
                                  style="cursor: pointer;"  [matTooltip]="'Click to view questions'">assignment
                        </mat-icon>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row
                    *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                    [ngClass]="{'row-selected': tableRowIdx == Idx}"
                    (dblclick)="doInvokeQualificationMapping($event)"
                    (click)="onRowClicked(row)">
                </tr>
            </table>
        </div>
        <!-------------------------------------->
        <!-- Control Strip                    -->
        <!-------------------------------------->
        <div class="mat-elevation-z2 control-strip">
            <button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
                    matTooltipPosition="above"
                    class="command-button" matTooltip="Add a new record"
                    (click)="addModifyRecord(true)" mat-button>
                <mat-icon>add_circle_outline</mat-icon>
                Add New
            </button>
            <button *ngIf="visibleModify" mat-button class="command-button"
                    matTooltipPosition="above"
                    style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
                    matTooltip="Edit a selected record" (click)="addModifyRecord(false)"
                    mat-button>
                <mat-icon>edit</mat-icon>
                Edit
            </button>
            <button *ngIf="visibleDelete" mat-button class="command-button"
                    matTooltipPosition="above"
                    style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
                    matTooltip="Remove a selected record" (click)="removeRecord()"
                    mat-button>
                <mat-icon>remove_circle_outline</mat-icon>
                Remove
            </button>
            <!-- <button *ngIf="visibleQualificationsMappingButton" mat-button class="command-button"
                    matTooltipPosition="above"
                    style="margin-top: 5px;float: right;margin-right: 10px;width: 150px;" [disabled]="(Idx < 0 || this.isEditing)"
                    matTooltip="Show qualifications assoociated with this record" (click)="openQualificationsDialog();"
                    mat-button>
                <mat-icon>playlist_add</mat-icon>
                Qualifications
            </button> -->
        </div>
        <!------------------------------->
        <!--  Detail panel             -->
        <!------------------------------->
        <div id="servicedefs-details-panel" class="servicedefs-detail-container mat-elevation-z2"
             style="margin-bottom: 2px;">
            <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange($event)"
                           [(selectedIndex)]=selectedTabIndex>
                <mat-tab label="Details" [disabled]="isEditing">
                    <div class="sub-tab-container-class detail-tab-additional">
                        <div class="dwform" style="padding-right: 15px;">

                            <div class="dwform-cell-nopadding" style="width: 350px">
                                <div class="dwform-row-double-gap"></div>

                                <label class="label-field"
                                       matTooltipPosition="above"
                                       matTooltip="This is a unique Id provided by the system">ID:</label> <span
                                    class="form-required"> </span>
                                <input class="input-field-short" id="serviceDefId" style="width:80px"
                                       disabled="true"
                                       [(ngModel)]="id"
                                       type="text">

                                <div class="dwform-row-gap"></div>

                                <label class="label-field"
                                       matTooltipPosition="above"
                                       matTooltip="This best describes the general category of the service being provided"
                                >Request Type:</label>
                                <span class="form-required">*</span>

                                <dw-dropdown
                                        id="serviceTypeId"
                                        [disabled]="!isEditing || !isAdd"
                                        [selectedItem]="serviceRequestTypeId"
                                        (itemSelected)="serviceRequestTypeId = $event; setServiceType();"
                                        [dataSource]="serviceRequestTypes"
                                        [controlWidth]="'320px'" >
                                </dw-dropdown>


                                <div class="dwform-row-gap"></div>

                                    <label class="label-field"
                                           matTooltipPosition="above"
                                           matTooltip="This is the description of the service being provided"
                                    >Description:</label>
                                    <span class="form-required">*</span>
                                    <input class="input-field-long" id="description" [disabled]="!isEditing"
                                           style="text-transform: capitalize"
                                           [(ngModel)]="description"
                                           placeholder="<Service Description>"
                                           type="text">

                                <div class="dwform-row-gap"></div>

                                <label class="label-field"
                                       matTooltipPosition="above"
                                    matTooltip="This is how the service will be measured"
                                >Unit Of Measure:</label>
                                <span class="form-required">*</span>

                                <dw-dropdown
                                        [disabled]="!isEditing"
                                        [controlWidth]="'180px'"
                                        [dataSource]="uomList"
                                        (itemSelected)="unitOfMeasure = $event"
                                        [selectedItem]="unitOfMeasure">
                                </dw-dropdown>


                                <div class="dwform-row-gap"></div>

                                <label class="label-field"
                                    matTooltipPosition="above"
                                    matTooltip="The duration represents the number of days to provide the service for a request">Assessment Period:</label>
                                <span class="form-required">*</span>
                                <input class="input-field-shortest" id="durationDays" [disabled]="!isEditing"
                                       style="text-transform: capitalize"
                                       [(ngModel)]="durationDays"
                                       placeholder="<Duration>"
                                       type="number"> (In Days)

                                <div class="dwform-row-gap"></div>

                                <!-- Use Automatch and Status -->

                                <label class="label-field" *ngIf="visibleAutoMatch"
                                       matTooltipPosition="above"
                                       matTooltip="This specifies if this service participates in the automatch process"
                                >Use Automatch:</label>
                                <span class="form-required" *ngIf="visibleAutoMatch">*</span>

                                <dw-dropdown *ngIf="visibleAutoMatch"
                                        id="useAutomatchId"
                                        [disabled]="!isEditing || !automatchEnabled"
                                        [selectedItem]="useAutomatch"
                                        (itemSelected)="useAutomatch = $event"
                                        [controlWidth]="'120px'" [useStatusOptions]="'status'">
                                </dw-dropdown>

                                <!-- STATUS -->

                                <label class="label-field-half" *ngIf="visibleStatus"
                                        matTooltipPosition="above"
                                        matTooltip="This specifies if this service is currently available"
                                    >Status:</label>
                                    <span class="form-required" *ngIf="visibleStatus">*</span>

                                    <dw-dropdown *ngIf="visibleStatus"
                                            id="activeStatusId"
                                            [disabled]="!isEditing || !statusEnabled"
                                            [useStatusOptions]="'statusdiscontinued'"
                                            [selectedItem]="activeStatus"
                                            (itemSelected)="activeStatus = $event"
                                            [controlWidth]="'120px'" >
                                    </dw-dropdown>
                                    
                                 <div class="dwform-row-gap"></div>

                                <!-- Repeatable and Repeat Frequency -->
								 <label class="label-field"
                                       matTooltipPosition="above"
                                       matTooltip="This will specify whether the request is repeatable or not."
                                >Repeatable:</label>
                                <span class="form-required"></span>
                                <dw-dropdown
                                            id="repeatableId"
                                            [disabled]="!isEditing"
                                            [useStatusOptions]="'yesnoonly'"
                                            [selectedItem]="repeatable"
                                            (itemSelected)="repeatable = $event"
                                            [controlWidth]="'60px'" >
                                </dw-dropdown>
                                
                                
                                <label class="label-field" style="padding-left: 20px;"
                                       matTooltipPosition="above"
                                       matTooltip="This will specify the interval that will be used for when the next due date is for cloned requests."
                                >Repeat Frequency:</label>
                                <span class="form-required"></span>

                                 <input class="input-field-shortest" id="repeatFrequency" [disabled]="!isEditing || repeatable === 'No'"
                                       style="text-transform: capitalize; width: 100px;margin-left: -5px;"
                                       [(ngModel)]="repeatFrequency"
                                       placeholder="<days>"
                                       min="0" max="4000"
                                       type="number"> (In days)
                               
                            </div>

                            <div class="dwform-cell">

                              <!-- this is where the counties / zip codes go -->

                                <label
                                        matTooltipPosition="above"
                                        matTooltip="Specifies the county and zip code where the service is available"
                                        style="padding-bottom: 2px;">Service
                                    available in the following
                                    regions:</label>
                                <span class="form-required"> </span>

                                <app-regions #regions [disabledFlag]="!isEditing" ></app-regions>
                            </div>

                            <div class="dwform-cell">

                                <!-- this is where the counties / zip codes go -->

                                <label style="padding-bottom: 2px;"
                                       matTooltipPosition="above"
                                       matTooltip="Select all days to accept application submissions and ensure ability to meet the duration time frame.">
                                    Days available to receive applications:</label>
                                <span class="form-required"> </span>

                                <mat-selection-list #shoes class="dow-container"
                                                    [disabled]="!isEditing"
                                                    (selectionChange)="dowSelectionChange($event)"
                                                    [(ngModel)]="selectedDow">
                                    <mat-list-option *ngFor="let dow of dowList" checkboxPosition="before"
                                                     [value]="dow.id" [selected]="dowSet.get(dow)">
                                        {{dow.description}}
                                    </mat-list-option>
                                </mat-selection-list>

                            </div>
                            <!----------------------->
                            <!-- ERROR LINE --------->
                            <!----------------------->
                            <div class="error-line" [hidden]='!strErr.length'
                                 style="text-align:left;bottom: 8px;">{{strErr}}</div>
                            <!----------------------->
                            <!-- SAVE STRIP        -->
                            <!----------------------->
                            <div class="save-close-strip" style="bottom: 3px;">

                                <button mat-button class="command-button" *ngIf="this.isEditing"
                                        (click)="submitRecord()" matTooltip="Save the record"
                                        mat-button>
                                    <mat-icon>check_circle_outline</mat-icon>
                                    Submit
                                </button>
                                <button mat-button class="command-button" *ngIf="this.isEditing"
                                        (click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
                                    <mat-icon>highlight_off</mat-icon>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="History" [disabled]="isEditing">
                    <div class="sub-tab-container-class detail-tab-additional">
                        <transaction-history #history></transaction-history>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>

<p-dialog *ngIf="displayQualificationsMappingDlg" [header]="'Qualification Questions'" [focusOnShow]="true"
          [(visible)]="displayQualificationsMappingDlg" [modal]="true"
          [style]="{ 'width': '1200px', 'height': '718px', 'min-width': '1200px', 'min-height': '718px' }"
          appendTo="body"
          [minY]="45" [resizable]="false" [closable]="false">
    <app-servicedef-qualifications-mapping #qualificationsMapping [selectedServiceDef]="selectedRecord"
        (closeEvent)="displayQualificationsMappingDlg=false" >
    </app-servicedef-qualifications-mapping>
     <ng-template pTemplate="footer">
              <div style="text-align: center;">  
			<button mat-button class="command-button" 
			                           (click)="closeQualificationsMappingDialog()" matTooltip="Close window"
					  mat-button>
				  <mat-icon>cancel</mat-icon>
				  Close
			  </button>
		</div>
        </ng-template>
</p-dialog>
